import { classifyHostname, isValidTenantSlug } from "../config/domains";

export function resolveTenant(hostname: string, configuredTenant?: string): string {
  const normalized = hostname.split(":")[0]?.toLowerCase() ?? "";
  const surface = classifyHostname(normalized, configuredTenant);
  if (surface.kind === "tenant") return surface.slug;
  const parts = normalized.split(".").filter(Boolean);
  if (parts.length >= 3 && parts[0] && isValidTenantSlug(parts[0])) return parts[0];
  return configuredTenant?.trim() || "local";
}
